import React from 'react';
import UnitsPage from './UnitsPage';

const DollysPage = () => {
  return <UnitsPage tipoUnidad="Dolly" title="Dollys" />;
};

export default DollysPage;
